// extracted by mini-css-extract-plugin
export var brand = "_9f-9";
export var compact = "_9f-6";
export var extraSmall = "_9f-7";
export var icon = "_9f-0";
export var large = "_9f-4";
export var light = "_9f-1";
export var medium = "_9f-5";
export var outline = "_9f-b";
export var primaryDark = "_9f-a";
export var primaryLight = "_9f-8";
export var primaryModern = "_9f-c";
export var success = "_9f-2";
export var successSolid = "_9f-3";